<template>
  <span class="delivery-lead-time">{{valueString}} {{unit}}</span>
</template>

<script>
import camelCase from 'lodash/camelCase';

export default {
  name: 'DeliveryLeadTime',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isRange() {
      return this.value.min !== this.value.max;
    },
    unit() {
      let cardinality = 'plural';
      if (!this.isRange && this.value.min === 1) {
        cardinality = 'singular';
      }
      const unit = camelCase(this.value.unit);
      return this.$t(`units.deliveryLeadTimes.${cardinality}.${unit}`);
    },
    valueString() {
      let str = this.value.min.toString();
      if (this.isRange) str += `-${this.value.max}`;
      return str;
    },
  },
};
</script>



// WEBPACK FOOTER //
// DeliveryLeadTime.vue?db133d0c